export function getIutkCookie() {
    if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
        const cookies = document.cookie
            .split(';')
            .map(i => i.trim())
            .filter(item => item.startsWith(`iutk=`));
        if (cookies.length) {
            return cookies[0].split('=')[1].trim();
        }
    }
    return null;
}
